import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStopAction } from "../redux/actions/loadingActions";

export default function SimpleBackdrop() {
  const {loading } = useSelector((state) => state.loadingReducer)
  const dispatch = useDispatch()
  const handleClose = () => {
    dispatch(loadingStopAction())
  };

  return (
    <div>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
